const messages = {
  contactMe: {
    id: 'contactMe',
    defaultMessage: 'Contact Me',
  },
  sentMessage: {
    id: 'sentMessage',
    defaultMessage: 'Message Sent',
  },
  yourName: {
    id: 'yourName',
    defaultMessage: 'Your Name',
  },
  yourEmail: {
    id: 'yourEmail',
    defaultMessage: 'Your Email',
  },
  message: {
    id: 'message',
    defaultMessage: 'Message',
  },
  sendMessage: {
    id: 'sendMessage',
    defaultMessage: 'Send Message'
  },
  username: {
    id: 'username',
    defaultMessage: 'Username',
  },
  password: {
    id: 'password',
    defaultMessage: 'Password',
  },
  oldPassword: {
    id: 'oldPassword',
    defaultMessage: 'Old Password',
  },
  required: {
    id: 'required',
    defaultMessage: 'Required',
  },
  login: {
    id: 'login',
    defaultMessage: 'Login',
  },
  changePassword: {
    id: 'changePassword',
    defaultMessage: 'Change Password',
  },
  confirmPassword: {
    id: 'confirmPassword',
    defaultMessage: 'Confirm Password',
  },
  passwordsMustMatch: {
    id: 'passwordsMustMatch',
    defaultMessage: 'Passwords must match',
  },
  language: {
    id: 'language',
    defaultMessage: 'Language',
  },
  size: {
    id: 'size',
    defaultMessage: 'Size',
  },
  save: {
    id: 'save',
    defaultMessage: 'Save',
  },
  email: {
    id: 'email',
    defaultMessage: 'Email',
  },
  invalidEmail: {
    id: 'invalidEmail',
    defaultMessage: 'Provide a valid email',
  },
  register: {
    id: 'register',
    defaultMessage: 'Register',
  },
  loggedIn: {
    id: 'loggedIn',
    defaultMessage: 'You are logged in.',
  },
  noAccount: {
    id: 'noAccount',
    defaultMessage: 'Don\'t have an account?',
  },
  createAccount: {
    id: 'createAccount',
    defaultMessage: 'Create an account',
  },
  logout: {
    id: 'logout',
    defaultMessage: 'Logout',
  },
  loggedOut: {
    id: 'loggedOut',
    defaultMessage: 'You are now logged out',
  },
  returnToPuzzles: {
    id: 'returnToPuzzles',
    defaultMessage: 'Return to Puzzles',
  },
  passwordUpdated: {
    id: 'passwordUpdated',
    defaultMessage: 'Password Updated',
  },
  settings: {
    id: 'settings',
    defaultMessage: 'Settings',
  },
  settingsUpdated: {
    id: 'settingsUpdated',
    defaultMessage: 'Settings Updated',
  },
  ajaxError: {
    id: 'ajaxError',
    defaultMessage: 'There was a problem. Try again later',
  },
};

export default messages;
